export interface weddingDay {
  year: number;
  name: string;
}

export function getDays(): weddingDay[] {
  let weddingDayList: weddingDay[] = [
    { year: 1, name: "Papierhochzeit" },
    { year: 2, name: "Baumwollhochzeit" },
    { year: 3, name: "Lederhochzeit" },
    { year: 4, name: "Seidenhochzeit" },
    { year: 5, name: "Hölzerne Hochzeit / Gummihochzeit" },
    { year: 6, name: "Zuckerhochzeit" },
    { year: 7, name: "Kupferne Hochzeit" },
    { year: 8, name: "Blecherne Hochzeit" },
    { year: 9, name: "Keramikhochzeit" },
    { year: 10, name: "Rosenhochzeit" },
    { year: 11, name: "Stählerne Hochzeit" },
    { year: 12, name: "Nickelhochzeit" },
    { year: 12.5, name: "Petersilienhochzeit" },
    { year: 13, name: "Veilchenhochzeit" },
    { year: 14, name: "Elfenbeinhochzeit" },
    { year: 15, name: "Kristallhochzeit" },
    { year: 16, name: "Saphirhochzeit" },
    { year: 17, name: "Orchideenhochzeit" },
    { year: 18, name: "Türkishochzeit" },
    { year: 19, name: "Perlmutthochzeit" },
    { year: 20, name: "Porzellanhochzeit" },
    { year: 21, name: "Opalhochzeit" },
    { year: 22, name: "Bronzene Hochzeit" },
    { year: 23, name: "Titanhochzeit" },
    { year: 24, name: "Satinhochzeit" },
    { year: 25, name: "Silberhochzeit " },
    { year: 26, name: "Jadehochzeit" },
    { year: 27, name: "Mahagonihochzeit" },
    { year: 28, name: "Nelkenhochzeit" },
    { year: 29, name: "Samthochzeit" },
    { year: 30, name: "Perlenhochzeit" },
    { year: 31, name: "Lindenhochzeit" },
    { year: 32, name: "Seifenhochzeit" },
    { year: 33, name: "Zinnerne Hochzeit" },
    { year: 34, name: "Amberhochzeit" },
    { year: 35, name: "Leinenhochzeit" },
    { year: 36, name: "Smaragdhochzeit" },
    { year: 37, name: "Malachithochzeit" },
    { year: 37.5, name: "Aluminiumhochzeit" },
    { year: 38, name: "Feuerhochzeit" },
    { year: 39, name: "Sonnenhochzeit" },
    { year: 40, name: "Rubinhochzeit" },
    { year: 41, name: "Birkenhochzeit" },
    { year: 42, name: "Granathochzeit" },
    { year: 43, name: "Bleierne Hochzeit" },
    { year: 44, name: "Sternenhochzeit" },
    { year: 45, name: "Messinghochzeit" },
    { year: 46, name: "Lavendelhochzeit" },
    { year: 47, name: "Kaschmirhochzeit" },
    { year: 48, name: "Amethysthochzeit" },
    { year: 49, name: "Zedernhochzeit" },
    { year: 50, name: "Goldene Hochzeit" },
    { year: 51, name: "Weidenhochzeit" },
    { year: 52, name: "Topashochzeit" },
    { year: 53, name: "Uranhochzeit" },
    { year: 54, name: "Zeushochzeit" },
    { year: 55, name: "Platinhochzeit" },
    { year: 56, name: "Asternhochzeit" },
    { year: 57, name: "Jadehochzeit" },
    { year: 58, name: "Engelshochzeit" },
    { year: 59, name: "Gezeitenhochzeit" },
    { year: 60, name: "Diamanthochzeit" },
    { year: 61, name: "Ulmenhochzeit" },
    { year: 62, name: "Aquamarinhochzeit" },
    { year: 63, name: "Quecksilberhochzeit" },
    { year: 64, name: "Himmelshochzeit" },
    { year: 65, name: "Eiserne Hochzeit" },
    { year: 66, name: "Schnittlauchhochzeit" },
    { year: 67, name: "Steinerne Hochzeit" },
    { year: 70, name: "Gnadenhochzeit" },
    { year: 75, name: "Kronjuwelenhochzeit" },
    { year: 80, name: "Eichenhochzeit" },
    { year: 85, name: "Engelshochzeit" },
    { year: 90, name: "Marmorne Hochzeit" },
    { year: 100, name: "Himmelshochzeit" },
  ];
  return weddingDayList;
}
